import styled from 'styled-components'
import { Pagination } from '@mui/material'

import { useTableData } from '@/hooks/useTableData'
import { useSearchParams } from '@/hooks/useSearchParams'

import CustomView from '../CustomView'

interface ITablePagination {
  totalCount: number
  disableSearchParams?: boolean
}

const CustomPagination = styled(Pagination)`
  .MuiButtonBase-root {
    font-size: 14px;
  }
`
function TablePagination({ totalCount, disableSearchParams = false }: ITablePagination) {
  const { PER_PAGE, CURRENTE_PAGE, SET_CURRENT_PAGE } = useTableData()
  const {includeParamsToUrl} = useSearchParams()
  const totalPages = Math.ceil(totalCount / PER_PAGE)

  function handlePage(_: any, page: number) {
    SET_CURRENT_PAGE(page)
    if(!disableSearchParams) includeParamsToUrl({ page })
  }

  return (
    <CustomView flexDirection="row" justifyContent="flex-end">
      <CustomPagination
        count={totalPages}
        page={CURRENTE_PAGE}
        style={{ fontSize: '14px' }}
        onChange={handlePage}
      />
    </CustomView>
  )
}

export default TablePagination
